import { render, staticRenderFns } from "./NvBottomNav.vue?vue&type=template&id=7f507907&scoped=true&"
import script from "./NvBottomNav.vue?vue&type=script&lang=js&"
export * from "./NvBottomNav.vue?vue&type=script&lang=js&"
import style0 from "./NvBottomNav.vue?vue&type=style&index=0&id=7f507907&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f507907",
  null
  
)

export default component.exports